// extracted by mini-css-extract-plugin
module.exports = {"root":"ToggleTabs_root__gKamM"};